export default __webpack_public_path__ + "static/media/intro1.f2d464b6.png";